export class UploadInitRequest {
    key: string = "";
    storageLocationId: string = "";
}